import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./signup.css";

const SignupForm = () => {
  const navigate = useNavigate();

  const closeModal = () => {
    navigate(-1); // Go back to previous page
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        closeModal();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  const redirectTo = (type) => {
    const url =
      type === "candidate"
        ? "https://jobs.skillshap.com/candidate/create-account"
        : "https://jobs.skillshap.com/employer/account/signup";
    window.location.href = url;
  };

  return (
    <div className="modal-overlay" onClick={closeModal}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={closeModal}>✖</button>

        <h2 className="modal-title">SIGN UP</h2>
        <p className="modal-subtitle">Choose your Sign Up type to continue</p>

        <div className="toggle-tabs">
          <button className="submit-btn" onClick={() => redirectTo("candidate")}>
           Candidate Sign Up
          </button>
          <button className="submit-btn" onClick={() => redirectTo("recruiter")}>
           Recruiter Sign Up
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignupForm;